const BASE_URL_USER = process.env.REACT_APP_BASE_URL_USER;
const BASE_URL_INVENTORY = process.env.REACT_APP_BASE_URL_INVENTORY;
const BASE_URL_ORDER = process.env.REACT_APP_BASE_URL_ORDER;
const BASE_URL_MESSAGE = process.env.REACT_APP_BASE_URL_MESSAGE;
const BASE_URL_SOCKET = process.env.REACT_APP_BASE_URL_SOCKET;
const BASE_URL_SUPPORT = process.env.REACT_APP_BASE_URL_SUPPORT;
const REACT_APP_IS_BELT = process.env.REACT_APP_IS_BELT;

export {
  BASE_URL_INVENTORY, BASE_URL_MESSAGE, BASE_URL_ORDER, BASE_URL_SOCKET,
  BASE_URL_SUPPORT, BASE_URL_USER, REACT_APP_IS_BELT
};

const USER_BASE_URL = `${BASE_URL_USER}/user`;
const INVENTORY_BASE_URL = `${BASE_URL_INVENTORY}/inventory`;
const ORDER_BASE_URL = `${BASE_URL_ORDER}/order`;
const  SUPPORT_BASE_URL = `${BASE_URL_SUPPORT}/support`;

export const Url = {

  REACT_APP_IS_BELT : REACT_APP_IS_BELT,

  BASE_URL_SOCKET: BASE_URL_SOCKET,

  UPS_TRACK_NUMBER_URL: 'https://www.ups.com/track?loc=en_US&tracknum=',

  GET_ALL_USERS: `${USER_BASE_URL}/getAllApprovedUsers`,

  GET_ALL_DELETED_USERS: `${USER_BASE_URL}/getAllDeletedUsers`,

  LOGIN: `${BASE_URL_USER}/auth/login`,

  SIGNUP: `${BASE_URL_USER}/noAuth/signup`,

  LOGOUT: `${BASE_URL_USER}/user/logout`,

  SEND_INVITE: `${BASE_URL_USER}/mail/sendInviteMail`,

  USER_REGISTRATION: `${BASE_URL_USER}/noAuth/register`,

  GET_EMAIL_BY_ID: `${BASE_URL_USER}/noAuth/getEmail`,

  CHECK_EMAIL_EXIST_OR_NOT: `${BASE_URL_USER}/noAuth/checkEmailExistOrNot`,

  ADD_USER : `${USER_BASE_URL}/addUser`,

  ADD_COMPANY : `${USER_BASE_URL}/addCompany`,

  GET_USER_ROLES : `${BASE_URL_USER}/role/getAllRoles`,

  GET_ALL_PERMISSIONS : `${BASE_URL_USER}/permission`,

  GET_ROLE_NAME_BY_ID : `${BASE_URL_USER}/role/getRole`,

  GET_ALL_SERVICE_TYPE : `${BASE_URL_SUPPORT}/customerSupport/getAllServiceType`,

  FETCH_CUSTOMER_SERVICE_REQUEST_HISTORY : `${BASE_URL_SUPPORT}/customerSupport/fetchCustomerServiceRequestHistory`,

  FETCH_CUSTOMER_SERVICE_REQUEST_DOCS : `${BASE_URL_SUPPORT}/customerSupport/fetchCustomerServiceRequestDocs`,

  FETCH_CUSTOMER_SERVICE_REQUEST_DOCS_FOR_EDITING : `${BASE_URL_SUPPORT}/customerSupport/fetchCustomerServiceRequestDocsForEditing`,

  GET_CUSTOMER_SERVICE_REQUEST : `${BASE_URL_SUPPORT}/customerSupport/getServiceRequest`,

  GET_CUSTOMER_SERVICE_REQUEST_FOR_EDITING : `${BASE_URL_SUPPORT}/customerSupport/getServiceRequestForEditing`,

  DOWNLOAD_CUSTOMER_SERVICE_REQUEST_DOC : `${BASE_URL_SUPPORT}/customerSupport/downloadCustomerServiceRequestDOC`,

  GET_FIELD_BY_SERVICE_TYPE : `${BASE_URL_SUPPORT}/customerSupport/getField`,

  SAVE_CUSTOMER_SUPPORT_REQUEST : `${BASE_URL_SUPPORT}/customerSupport/save`,

  SAVE_CUSTOM_SAMPLE_REQUEST : `${BASE_URL_SUPPORT}/customerSupport/saveCustomSampleRequest`,

  GET_CUSTOMER_SUPPORT_REQUESTS :  `${BASE_URL_SUPPORT}/customerSupport/getAllServiceRequests`,

  DELETE_CUSTOMER_SUPPORT_REQUEST : `${BASE_URL_SUPPORT}/customerSupport/deleteCustomerServiceRequest`,

  DELETE_CUSTOMER_SUPPORT_REQUEST_DOC : `${BASE_URL_SUPPORT}/customerSupport/deleteCustomerServiceRequestDoc`,

  UPDATE_CUSTOMER_SUPPORT_REQUEST : `${BASE_URL_SUPPORT}/customerSupport/updateStatus`,

  GET_USER_LIST_BY_COMPANY_ID: `${USER_BASE_URL}/getUsersListByCompanyId`,

  UPDATE_ROLE_DESCRIPTION: `${BASE_URL_USER}/role/updateDescription`,

  SAVE_ROLES_AND_PERMISSIONS : `${BASE_URL_USER}/permission`,

  SAVE_SUPPORT_REQUEST : `${SUPPORT_BASE_URL}/save`,

  GET_SUPPORT_REQUEST :  `${SUPPORT_BASE_URL}/getAllSupportRequests`,

  GET_ALL_COMMENTS : `${SUPPORT_BASE_URL}/getComments`,

  OPEN_SUPPORT_REQUEST_COUNT : `${SUPPORT_BASE_URL}/openRequestCount`,

  CLOSE_SUPPORT_REQUEST_COUNT : `${SUPPORT_BASE_URL}/closeRequestCount`,

  UPDATE_SUPPORT_REQUEST_STATUS : `${SUPPORT_BASE_URL}/updateStatus`,

  DOWNLOAD_SUPPORT_REQUEST_FILE : `${SUPPORT_BASE_URL}/downloadFile`,

  GET_ALL_ROLES: `${BASE_URL_USER}/noAuth/getAllRoles`,

  GET_SUBMITTED_USERS: `${USER_BASE_URL}/getAllSubmittedUsers`,

  UPDATE_USER_STATUS: `${USER_BASE_URL}/updateStatus`,

  BULK_REMOVE_PROFILES: `${USER_BASE_URL}/bulkRemoveById`,

  HARD_DELETE_USERS: `${USER_BASE_URL}/bulkHardDeleteById`,

  GET_REJECTED_USER_COUNT: `${USER_BASE_URL}/getRejectedUserCount`,

  GET_ACTIVE_USER_COUNT: `${USER_BASE_URL}/getAllActiveUsersCount`,
  
  GET_DELETE_USER_COUNT: `${USER_BASE_URL}/getAllDeleteUsersCount`,

  GET_ALL_REJECTED_USERS: `${USER_BASE_URL}/getRejectedUser`,

  GET_CITY_AND_STATE: `${BASE_URL_USER}/usps/cityStateLookup`,

  SAMPLE_ORDER_REQUEST: `${BASE_URL_ORDER}/sampleRequest/sampleOrderRequest`,

  IS_SAMPLE_ORDER_REQUEST_CREATED: `${BASE_URL_ORDER}/sampleRequest/isSampleRequestCreated`,

  UPDATE_SAMPLE_ORDER_REQUEST: `${BASE_URL_ORDER}/sampleRequest/updateSampleRequest`,

  SAVE_PURCHASE_OFFER: `${BASE_URL_ORDER}/offerRequest/purchaseOfferRequest`,

  IS_PURCHASE_OFFER_REQUEST_CREATED: `${BASE_URL_ORDER}/offerRequest/isPurchaseOfferCreated`,

  UPDATE_PURCHASE_OFFER_REQUEST: `${BASE_URL_ORDER}/offerRequest/updatePurchaseOfferRequest`,

  RESET_PASSWORD: `${BASE_URL_USER}/noAuth/savePassword`,

  GET_ALL_INVENTORY: `${INVENTORY_BASE_URL}/getProductsByFilters`,

  GET_PRODUCT_BY_ID: `${INVENTORY_BASE_URL}/getProductById/`,

  GET_BARREL_BY_ID: `${BASE_URL_INVENTORY}/barrel/getBarrelById/`,

  EDIT_BARREL: `${BASE_URL_INVENTORY}/barrel/editBarrel`,

  GET_PROOF_HISTORY_BY_BARREL_NUMBER: `${BASE_URL_INVENTORY}/barrel/getProofHistoryByBarrelNumber`,

  GET_VALUATION_HISTORY_BY_BARREL_ID: `${BASE_URL_INVENTORY}/barrel/getValuationHistoryByBarrelId`,

  GET_INVENTORY_LIST_BY_COMPANY_ID: `${INVENTORY_BASE_URL}/getInventoryList`,

  SEARCH_INVENTORY: `${INVENTORY_BASE_URL}/search`,

  UPLOAD_CSV: `${INVENTORY_BASE_URL}/upload`,

  GET_ALL_TYPE_AND_FACILITY: `${INVENTORY_BASE_URL}/getAllTTBtypesAndFacilities`,
  
  GET_ALL_LOCATIONS: `${BASE_URL_INVENTORY}/locations/warehouse`,

  GET_WAREHOUSE_DROPDOWN: `${BASE_URL_INVENTORY}/locations/warehouse/dropdown`,

  GET_ALL_STAGING_AREAS: `${BASE_URL_INVENTORY}/locations/stagingAreaDropdown`,

  GET_BARREL_DETAILS_BY_LOCATION: `${BASE_URL_INVENTORY}/locations/getBarrelsByLocation`,

  GET_MAX_WAREHOUSE_ROW: `${BASE_URL_INVENTORY}/locations/row`,

  GET_MAX_WAREHOUSE_STACK: `${BASE_URL_INVENTORY}/locations/stack`,

  GET_PALLET_WITH_BARREL_DETAILS: `${BASE_URL_INVENTORY}/locations/getPalletDetails`,

  GET_ALL_PALLETS: `${BASE_URL_INVENTORY}/pallets/warehouse`,

  GET_PALLET_DETAILS: `${BASE_URL_INVENTORY}/pallets`,

  GET_USER_BY_USER_ID: `${USER_BASE_URL}/getById/`,

  // GET_INVENTORY_CSV: `${BASE_URL_INVENTORY}/inventoryCSV/getInventorySellRequests`,

  READ_CSV: `${BASE_URL_INVENTORY}/inventoryCSV/readCSV`,

  GET_SUBMITTED_USER_COUNT: `${USER_BASE_URL}/getCountForSubmittedUsers`,

  UPDATE_INVENTORY_CSV: `${BASE_URL_INVENTORY}/inventoryCSV/updateInventoryCsv`,

  UPDATE_STATUS_IN_BULK: `${USER_BASE_URL}/updateStatusForMultipleUsers`,

  GET_INVENTORY_CSV_WITH_DOCS: `${BASE_URL_INVENTORY}/inventoryCSV/getInventorySellRequestWithDocs`,

  DOWNLOAD_CSV: `${BASE_URL_INVENTORY}/inventoryCSV/downloadCSV`,

  DOWNLOAD_INVENTORY_TEMPLATE: `${BASE_URL_INVENTORY}/inventoryCSV/downloadInventoryTemplate`,

  DOWNLOAD_DOC: `${BASE_URL_INVENTORY}/inventoryCSV/downloadDOC`,

  DOWNLOAD_EXPORT_BARREL: `${BASE_URL_INVENTORY}/inventory/downloadExportFile`,

  DOWNLOAD_FACILITIES_EXPORT_BARREL: `${BASE_URL_INVENTORY}/inventory/downloadFacilitiesExportFile`,

  DOWNLOAD_OWNERSHIP_TRANSFER_EXPORT_BARREL: `${BASE_URL_SUPPORT}/customerSupport/downloadOwnershipTransferExportFile`,

  DOWNLOAD_ZIP_WITH_DOCS: `${BASE_URL_INVENTORY}/inventoryCSV/getZipWithDocs`,

  GET_LOGIN_HISTORY: `${BASE_URL_USER}/getLoginHistory`,

  // GET_LOCATION_DETAILS: `https://geolocation-db.com/json/709bbed0-fb73-11ee-8070-55ec9ebae196`,
  GET_LOCATION_DETAILS: `https://api.ipbase.com/v1/json/`,

  GET_ORDER_ITEMS: `${BASE_URL_ORDER}/orderItems/getOrderItems`,

  GET_ORDER_ITEM_BY_ID : `${BASE_URL_ORDER}/orderItems/getOrderItem`,

  UPDATE_ORDER_ITEM: `${BASE_URL_ORDER}/orderItems/updateOrderItem`,
  
  UPDATE_ORDER_ITEM_STATUS: `${BASE_URL_ORDER}/orderItems/updateOrderItemStatus`,

  SAVE_ORDER_ITEMS: `${BASE_URL_ORDER}/orderItems/save`,

  UPDATE_ORDER_ITEM_ACTIVE_STATUS: `${BASE_URL_ORDER}/orderItems/updateOrderItemActiveStatus`,

  GET_ORDER_ITEM_BY : `${BASE_URL_ORDER}/orderItem`,

  PLACE_ORDER: `${BASE_URL_ORDER}/order/placeOrder`,

  GET_ACTIVE_ORDERS: `${BASE_URL_ORDER}/orderItems/getActiveOrders`,

  GET_SAMPLE_REQUEST: `${BASE_URL_ORDER}/sampleRequest/getActiveSampleRequests`,

  GET_OFFER_REQUEST: `${BASE_URL_ORDER}/offerRequest/getActiveOfferRequest`,

  ADD_TO_WISH_LIST: `${BASE_URL_ORDER}/wishList/addToWishlist`,

  GET_ALL_SOLD_INVENTORY_WISH_LIST: `${BASE_URL_ORDER}/wishList/getAllSoldInventoryWishList`,

  GET_WISHLIST_DETAILS: `${BASE_URL_ORDER}/wishList/getWishListDetails`,

  REMOVE_FROM_WISH_LIST: `${BASE_URL_ORDER}/wishList/removeFromWishlist`,

  REMOVE_FROM_WISH_LIST_BY_ID: `${BASE_URL_ORDER}/wishList/removeFromWishlistById`,

  GET_WISH_LIST: `${BASE_URL_ORDER}/wishList/getWishlist`,

  IS_INVENTORY_IN_WISH_LIST: `${BASE_URL_ORDER}/wishList/isInventoryInWishlist`,

  IS_INVENTORY_IN_CART_FOR_USER: `${BASE_URL_ORDER}/orderItems/isInventoryInCartForUser`,

  GET_ACCEPTED_ORDERS: `${BASE_URL_ORDER}/order/getAcceptedOrders`,

  GET_PENDING_ORDERS: `${BASE_URL_ORDER}/order/getPendingOrders`,

  GET_PENDING_ORDERS_COUNT: `${BASE_URL_ORDER}/order/getPendingOrdersCount`,

  UPDATE_ORDER_STATUS_BY_ORDER_ID: `${BASE_URL_ORDER}/orderItems/updateOrderStatus`,

  GET_ORDERS: `${BASE_URL_ORDER}/order/getOrders`,

  CHANGE_ORDER_STATUS: `${BASE_URL_ORDER}/order/changeOrderStatus`,

  GET_ORDER_BARRELS: `${BASE_URL_ORDER}/order/getOrderBarrels`,

  GET_ORDER_RESERVED_BARRELS_COUNT: `${BASE_URL_ORDER}/order/getOrderReservedBarrelsCount`,

  GET_SAME_INVENTORY_ORDERS : `${BASE_URL_ORDER}/order/getSameInventoryOrders`,

  CHECK_INVENTORY_HAS_MULTIPLE_ORDERS : `${BASE_URL_ORDER}/order/hasMultipleOrders`,

  UPDATE_RESERVED_BARREL_DETAILS_FOR_ORDER_REQUEST : `${BASE_URL_ORDER}/order/updateOrderReservedBarrelDetails`,

  UPDATE_RESERVED_BARREL_DETAILS_FOR_SAMPLE_REQUEST : `${BASE_URL_ORDER}/sampleRequest/updateReservedBarrelDetails`,

  CHANGE_OFFER_STATUS: `${BASE_URL_ORDER}/offerRequest/changeOfferStatus`,

  CHANGE_OWNER_STATUS_FOR_OFFER: `${BASE_URL_ORDER}/offerRequest/updateOwnerStatus`,

  GET_ALL_BARRELS_FOR_OFFER_REQUEST: `${BASE_URL_ORDER}/offerRequest/getAllBarrels`,

  GET_ALL_BARRELS_FOR_SAMPLE_REQUEST: `${BASE_URL_ORDER}/sampleRequest/getAllBarrels`,

  GET_RESERVED_BARRELS_COUNT_FOR_OFFER_REQUEST: `${BASE_URL_ORDER}/offerRequest/getReservedBarrelsCount`,

  GET_RESERVED_BARRELS_COUNT_FOR_SAMPLE_REQUEST: `${BASE_URL_ORDER}/sampleRequest/getReservedBarrelsCount`,

  CHANGE_SAMPLE_REQUEST_STATUS: `${BASE_URL_ORDER}/sampleRequest/updateStatus`,

  UPDATE_SAMPLE_REQUEST_OWNER_STATUS: `${BASE_URL_ORDER}/sampleRequest/updateOwnerStatus`,

  GET_ORDER_ITEMS_BY_ORDER_ID: `${BASE_URL_ORDER}/orderItems/getItemsByOrderId`,

  GET_ORDER_SUMMARY_BY_ORDER_ID: `${BASE_URL_ORDER}/orderItems/getOrderSummary`,

  GET_COMPANIES_CONTAINER_COUNT : `${BASE_URL_INVENTORY}/report/companiesContainerCount`,

  EXPORT_COMPANY_INVENTORY_SUMMARY: `${BASE_URL_INVENTORY}/report/exportCompanyInventorySummary`,
  
  DOWNLOAD_COMPANY_INVENTORY_SUMMARY_REPORT: `${BASE_URL_INVENTORY}/report/downloadCompanyInventorySummaryReport`,

  GET_COMPANY_BILLING_ACTIVITY : `${BASE_URL_INVENTORY}/report/getCompanyBillingActivity`,

  EXPORT_COMPANY_BILLING_ACTIVITY: `${BASE_URL_INVENTORY}/report/exportCompanyBillingActivity`,
  
  DOWNLOAD_COMPANY_BILLING_ACTIVITY_REPORT: `${BASE_URL_INVENTORY}/report/downloadCompanyBillingActivityReport`,

  GET_TTB_REPORT : `${BASE_URL_INVENTORY}/report/getTTBReport`,

  EXPORT_TTB_REPORT: `${BASE_URL_INVENTORY}/report/exportTTBReport`,
  
  DOWNLOAD_TTB_REPORT: `${BASE_URL_INVENTORY}/report/downloadTTBReport`,

  GET_SERVICE_REQUEST_BILLING_DETAIL: `${BASE_URL_INVENTORY}/report/getServiceRequestBillingDetail`,

  EXPORT_SERVICE_REQUEST_BILLING_DETAIL: `${BASE_URL_INVENTORY}/report/exportServiceRequestBillingDetail`,

  GET_SERVICE_REQUEST_BILLING_SUMMARY: `${BASE_URL_INVENTORY}/report/getServiceRequestBillingSummary`,

  EXPORT_SERVICE_REQUEST_BILLING_SUMMARY: `${BASE_URL_INVENTORY}/report/exportServiceRequestBillingSummary`,

  DOWNLOAD_SERVICE_REQUEST_BILLING_REPORT: `${BASE_URL_INVENTORY}/report/downloadServiceRequestBillingReport`,

  GET_BILLABLE_SERVICE_TYPES: `${BASE_URL_INVENTORY}/report/getBillableServiceTypes`,

  GET_COMPANY_BULK_INVENTORY_UPLOAD_REPORT: `${BASE_URL_INVENTORY}/report/getCompanyBulkInventoryUploadReport`,

  EXPORT_COMPANY_BULK_INVENTORY_UPLOAD_REPORT: `${BASE_URL_INVENTORY}/report/exportCompanyBulkInventoryUploadReport`,

  DOWNLOAD_COMPANY_BULK_INVENTORY_UPLOAD_REPORT: `${BASE_URL_INVENTORY}/report/downloadCompanyBulkInventoryUploadReport`,

  GET_ACTIVE_MESSAGES_BY_TYPE: `${BASE_URL_MESSAGE}/message/active/message`,

  SAVE_MESSAGES: `${BASE_URL_MESSAGE}/message/save`,

  GET_GROUP_MESSAGES: `${BASE_URL_MESSAGE}/message/getMessageGroups`,

  GET_ADMIN_MESSAGE_GROUP: `${BASE_URL_MESSAGE}/message/getAdminMessageGroups`,

  GET_OPEN_REQUEST_COUNT: `${BASE_URL_USER}/dashboard/getOpenRequestsCount`,

  GET_WAREHOUSE_OPEN_REQUEST_COUNT: `${BASE_URL_USER}/dashboard/getOpenRequestsCountForWarehouse`,

  GET_ALL_WAREHOUSE_USER: `${BASE_URL_USER}/dashboard/getAllWarehouseUser`,

  GET_ALL_WAREHOUSE_REQUEST: `${BASE_URL_USER}/dashboard/getAllRequestsForWarehouse`,

  GET_ALL_LOGISTIC_REQUEST: `${BASE_URL_SUPPORT}/customerSupport/getAllLogisticRequests`,

  GET_RECENT_REQUEST_COUNT: `${BASE_URL_USER}/dashboard/getRecentRequestsData`,

  GET_REQUEST_DATA: `${BASE_URL_USER}/dashboard/getRequestsData`,

  FETCH_UNREAD_MESSAGES: `${BASE_URL_MESSAGE}/message/fetchUnreadMessagesForLoggedInUser`,

  GET_CSVs_BY_SELL_REQUEST_ID: `${BASE_URL_INVENTORY}/inventoryCSV/getCSVListByReqId`,

  GET_SELL_REQ_BY_ID_WITH_COMPANY: `${BASE_URL_INVENTORY}/inventoryCSV/getSellReqById`,

  GET_DOCS_BY_SELL_REQUEST_ID: `${BASE_URL_INVENTORY}/inventoryCSV/fetchInventorySellRequestDoc`,

  GET_HISTORY_BY_SELL_REQUEST_ID: `${BASE_URL_INVENTORY}/inventoryCSV/fetchInventoryCsvHistory`,

  UPLOAD_DOC: `${INVENTORY_BASE_URL}/uploadDocs`,

  FETCH_COMPANIES_LIST: `${BASE_URL_USER}/company/getAllApprovedCompanies`,

  GET_ALL_ACTIVE_AND_INACTIVE_COMPANIES: `${BASE_URL_USER}/company/getAllActiveAndInactiveCompanies`,

  GET_COMPANY_DETAILS_BY_ID: `${BASE_URL_USER}/company/getCompanyDetails`,

  FETCH_COMPANIES_OPEN_REQUEST_COUNT: `${BASE_URL_USER}/company/getOpenRequestsCount`,

  FETCH_COMPANIES_USER_DATA: `${BASE_URL_USER}/company/getCompanyUsers`,
 
  FETCH_SAMPLE_REQUEST_BY_ID: `${BASE_URL_ORDER}/sampleRequest/getSampleRequestById`,

  FETCH_COMPANIES_BY_ID: `${BASE_URL_USER}/company/getCompanyById`,

  DELETE_COMPANIES_BY_ID: `${BASE_URL_USER}/company/deleteCompany`,

  SUSPEND_COMPANIES_BY_ID: `${BASE_URL_USER}/company/suspendCompany`,

  ACTIVE_COMPANIES_BY_ID: `${BASE_URL_USER}/company/activeCompany`,
  
  UPLOAD_SAMPLE_REQUEST_DOC: `${BASE_URL_ORDER}/sampleRequest/uploadSampleRequestDoc`,

  UPLOAD_CUSTOMER_SERVICE_REQUEST_DOC: `${BASE_URL_SUPPORT}/customerSupport/uploadCustomerServiceRequestDoc`,

  FETCH_UNREAD_MESSAGE_COUNT_FOR_CUSTOMER_SERVICE_REQUEST: `${BASE_URL_MESSAGE}/message/getUnreadMessageCountForCustomerServiceRequest`,

  FETCH_UNREAD_MESSAGE_COUNT_FOR_SELL_REQUEST: `${BASE_URL_MESSAGE}/message/getUnreadMessageCountForSellRequest`,

  FETCH_ALL_BARRELS_COUNT: `${BASE_URL_INVENTORY}/barrel/getAllBarrelsCount`,

  FETCH_SAMPLE_REQUEST_DOCS: `${BASE_URL_ORDER}/sampleRequest/fetchSampleRequestDocs`,

  FETCH_SAMPLE_REQUEST_HISTORY: `${BASE_URL_ORDER}/sampleRequest/fetchSampleRequestHistory`,

  DOWNLOAD_SAMPLE_REQUEST_DOC: `${BASE_URL_ORDER}/sampleRequest/downloadSampleRequestDOC`,

  UPLOAD_ORDER_REQUEST_DOC: `${BASE_URL_ORDER}/orderProcessing/uploadOrderRequestDoc`,

  FETCH_ORDER_REQUEST_DOCS: `${BASE_URL_ORDER}/orderProcessing/fetchOrderRequestDocs`,

  FETCH_ORDER_REQUEST_HISTORY: `${BASE_URL_ORDER}/orderProcessing/fetchOrderRequestHistory`,

  DOWNLOAD_ORDER_REQUEST_DOC: `${BASE_URL_ORDER}/orderProcessing/downloadOrderRequestDOC`,

  SHOW_PDF_URL: `${BASE_URL_INVENTORY}/inventoryCSV/viewPDF`,
 
  SHOW_PDF_FOR_ORDER_URL: `${BASE_URL_ORDER}/orderProcessing/viewPDF`,

  SHOW_PDF_FOR_OFFER_URL: `${BASE_URL_ORDER}/offerRequest/viewPDF`,

  SHOW_PDF_FOR_SAMPLE_URL: `${BASE_URL_ORDER}/sampleRequest/viewPDF`,

  GET_COMPANY_WISE_SELL_REQUEST: `${BASE_URL_INVENTORY}/inventoryCSV/getInventorySellRequestsByCompanyId`,

  GET_MY_INVENTORIES: `${INVENTORY_BASE_URL}/getMyInventories`,

  GET_INVENTORY_FILTER_OPTIONS: `${INVENTORY_BASE_URL}/getFilterOptions`,

  GET_ALL_WAREHOUSE_BARRELS: `${BASE_URL_INVENTORY}/barrel/getAllWarehouseBarrel`,   

  EXPORT_MY_INVENTORIES: `${INVENTORY_BASE_URL}/exportMyInventories`,

  GET_INVENTORY_CHANGE_REQUESTS: `${INVENTORY_BASE_URL}/getInventoryChangeRequests`,

  GET_ALL_INVENTORY_CHANGE_REQUESTS: `${INVENTORY_BASE_URL}/getAllInventoryChangeRequests`,

  GET_ALL_DUPLICATE_INVENTORY: `${INVENTORY_BASE_URL}/duplicateInventory`,

  GET_INVENTORY_CHANGE_REQUEST_BY_ID: `${INVENTORY_BASE_URL}/getInventoryChangeRequest`,

  UPDATE_INVENTORY_CHANGE_REQUEST_STATUS: `${INVENTORY_BASE_URL}/updateInventoryChangeRequestStatus`,

  GET_COMPANY_WISE_SAMPLE_REQUEST: `${BASE_URL_ORDER}/sampleRequest/getSampleRequestsByCompanyId`,

  GET_COMPANY_WISE_OFFER_REQUEST: `${BASE_URL_ORDER}/offerRequest/getOfferRequestByCompanyId`,

  UPDATE_RESERVED_BARREL_DETAILS_FOR_OFFER_REQUEST : `${BASE_URL_ORDER}/offerRequest/updateReservedBarrelDetails`,

  GET_COMPANY_WISE_ORDER_REQUEST: `${BASE_URL_ORDER}/order/getOrderRequestByCompanyId`,

  GET_COMPANY_WISE_ORDER_REQUEST_PAGINATION: `${BASE_URL_ORDER}/order/getOrderRequestByCompanyIdPagination`,

  REMOVE_ITEM_FROM_CART: `${BASE_URL_ORDER}/orderItems/removeItemFromCart`,

  FETCH_OFFER_REQUEST_BY_ID: `${BASE_URL_ORDER}/offerRequest/getOfferRequestById`,

  FETCH_OFFER_REQUEST_DOCS: `${BASE_URL_ORDER}/offerRequest/fetchOfferRequestDocs`,

  FETCH_OFFER_REQUEST_HISTORY: `${BASE_URL_ORDER}/offerRequest/fetchOfferRequestHistory`,

  UPLOAD_OFFER_REQUEST_DOC: `${BASE_URL_ORDER}/offerRequest/uploadOfferRequestDoc`,

  DOWNLOAD_OFFER_REQUEST_DOC: `${BASE_URL_ORDER}/offerRequest/downloadOfferRequestDOC`,

  GET_ALL_UNSEEN_NOTIFICATION_COUNT: `${BASE_URL_ORDER}/notification/getUnseenMessageCount`,

  FETCH_ALL_NOTIFICATION: `${BASE_URL_ORDER}/notification/getAllNotifications`,

  UPDATE_IS_SEEN_FLAG : `${BASE_URL_ORDER}/notification/updateIsSeenFlag`,

  UPDATE_USER: `${USER_BASE_URL}/updateUser`,
  
  CHANGE_PASSWORD: `${USER_BASE_URL}/changePassword`,

  UPLOAD_PROFILE_IMAGE: `${USER_BASE_URL}/uploadProfileImage`,

  GET_PROFILE_IMAGE: `${USER_BASE_URL}/getProfileImage`,

  SEND_RESET_PASSWORD_LINK: `${BASE_URL_USER}/noAuth/sendResetPasswordMail`,

  REMOVE_PROFILE_IMAGE: `${USER_BASE_URL}/removeProfileImage`,

  FETCH_ALL_COMPANIES_WITH_PAGINATION: `${BASE_URL_USER}/company/getAllCompaniesWithPagination`,

  FETCH_ALL_ACTIVE_COMPANIES: `${BASE_URL_USER}/company/getAllActiveCompanies`,

  EXPORT_COMPANIES: `${BASE_URL_USER}/company/exportCompanies`,

  DOWNLOAD_COMPANIES_REPORT: `${BASE_URL_USER}/company/downloadCompanyReport`,

  FETCH_ALL_SUSPENDED_COMPANIES: `${BASE_URL_USER}/company/getAllSuspendedCompanies`,

  FETCH_ALL_COMPANIES_COUNT: `${BASE_URL_USER}/company/getAllCompaniesCount`,

  FETCH_ALL_ACTIVE_COMPANIES_COUNT: `${BASE_URL_USER}/company/getAllActiveCompaniesCount`,

  FETCH_ALL_SUSPENDED_COMPANIES_COUNT: `${BASE_URL_USER}/company/getAllSuspendedCompaniesCount`,

  DOWNLOAD_CUSTOMER_SERVICE_REQUEST_VALUE_DOC : `${BASE_URL_SUPPORT}/customerSupport/downloadCustomerServiceRequestValueDOC`,

  SHOW_PDF_FOR_CUSTOMER_SERVICE_REQUEST: `${BASE_URL_SUPPORT}/customerSupport/viewPDF`,

  UPDATE_CUSTOMER_SUPPORT_REQUEST_VALUE : `${BASE_URL_SUPPORT}/customerSupport/updateCustomerServiceRequestValue`,

  GET_DYNAMIC_FIELD_VALUE_BY_SERVICE_REQUEST_ID : `${BASE_URL_SUPPORT}/customerSupport/getAllDynamicFieldValueByCustomerServiceRequestId`,

  GET_ALL_STATUS_BY_SERVICE_TYPE_ID :  `${BASE_URL_SUPPORT}/customerSupport/getStatusListByServiceId`,

  GET_SELL_REQUEST_EDIT_HISTORY : `${BASE_URL_SUPPORT}/customerSupport/getSellRequestEditHistory`,

  GET_EXPORT_REPORT : `${BASE_URL_SUPPORT}/customerSupport/exportReport`,

  UPDATE_SELL_REQUEST_FEE_DETAILS : `${BASE_URL_SUPPORT}/customerSupport/updateSellRequestFeeDetails`,

  UPDATE_SAMPLE_REQUEST_DETAILS : `${BASE_URL_SUPPORT}/customerSupport/updateSampleRequestDetails`,

  UPDATE_OWNERSHIP_TRANSFER_COMPANY_DETAILS : `${BASE_URL_SUPPORT}/customerSupport/updateOwnershipTransferRequestCompanyDetails`,

  FETCH_SELL_REQUEST_PRICING_HISTORY: `${BASE_URL_SUPPORT}/customerSupport/fetchSellRequestPricingHistory`,
  
  GET_MY_BARRELS_PRODUCT: `${INVENTORY_BASE_URL}/getMyBarrelsProduct`,

  EXPORT_MY_BARRELS_PRODUCT: `${INVENTORY_BASE_URL}/exportBarrelsProduct`,

  GET_INVENTORIES_LISTING: `${INVENTORY_BASE_URL}/getInventoryListing`,

  GET_INVENTORIES_LISTING_BY_INVENTORY_ID : `${INVENTORY_BASE_URL}/getInventoryListingByInventoryId`,

  GET_INVENTORIES_LISTING_BY_INVENTORY_ID_AND_STATUS : `${INVENTORY_BASE_URL}/getInventoryListingByInventoryIdAndStatus`,

  GET_PRODUCT_DETAILS_BY_INVENTORY_ID : `${INVENTORY_BASE_URL}/getProductDetails`,

  GET_SOLD_INVENTORIES_LISTING: `${INVENTORY_BASE_URL}/getSoldInventoryListing`,

  GET_SOLD_INVENTORIES_LISTING_BY_INVENTORY_ID : `${INVENTORY_BASE_URL}/getSoldInventoryListingByInventoryId`,

  GET_SOLD_INVENTORIES_LISTING_BY_INVENTORY_ID_AND_STATUS : `${INVENTORY_BASE_URL}/getSoldInventoryListingByInventoryIdAndStatus`,

  GET_SYNC_JOB_LOG: `${BASE_URL_INVENTORY}/barrel/getAllSyncJobLog`,

  EXPORT_KEGHOUND_BARREL_SYNC_LOG: `${BASE_URL_INVENTORY}/barrel/exportKeghoundBarrelSyncLog`,

  GET_OWNERSHIP_TRANSFER_LOG: `${BASE_URL_INVENTORY}/barrel/getAllOwnershipTransferLog`,

  GET_OWNERSHIP_TRANSFER_LOT_LOG: `${BASE_URL_INVENTORY}/barrel/getAllOwnershipTransferLotLog`,

  GET_OWNERSHIP_TRANSFER_LOT_LOG_BARREL: `${BASE_URL_INVENTORY}/barrel/getAllOwnershipTransferLotBarrels`,

  MANUAL_SYNC_BY_TRANSFER_REQUEST_ID: `${BASE_URL_INVENTORY}/barrel/manualSyncByTransferRequestId`,

  GET_BARREL_INSURANCE_PRICING: `${BASE_URL_INVENTORY}/insurance/getPrice`,

  GET_BARREL_MARKET_VALUES: `${BASE_URL_INVENTORY}/insurance/getMarketValue`,

  GET_BARREL_MARKET_VALUE_HISTORY: `${BASE_URL_INVENTORY}/insurance/getMarketValueHistory`,

  UPDATE_BARREL_MARKET_VALUE: `${BASE_URL_INVENTORY}/insurance/updateBarrelMarketValue`,

  SAVE_INSURANCE_PRICING: `${BASE_URL_INVENTORY}/insurance/save`,

  GET_MARKET_VALUE_WITH_FILTER: `${BASE_URL_INVENTORY}/insurance/marketValuesWithFilter`,

  GET_ALL_LOT_NO_BY_COMPANY_ID: `${BASE_URL_INVENTORY}/insurance/getLotNo`,

  DOWNLOAD_MARKET_VALUE_REPORT: `${BASE_URL_INVENTORY}/insurance/downloadMarketValueReport`,

  DOWNLOAD_REPORT: `${BASE_URL_SUPPORT}/customerSupport/downloadReport`,

  CHECK_ALL_BARREL_PROOFING_VALUE_PRESENT: `${BASE_URL_SUPPORT}/customerSupport/checkAllBarrelProofingValuePresent`,

  CHECK_ALL_BARREL_VALUATION_VALUE_PRESENT: `${BASE_URL_SUPPORT}/customerSupport/checkAllBarrelValuationValuePresent`,

  PROCESS_MARKET_VALUE_REPORT: `${BASE_URL_INVENTORY}/insurance/processMarketValueReport`,

  FETCH_COMPANNY_USER_DATA: `${BASE_URL_USER}/user/export-user-company-list`,

  SAVE_CONTRACT_SERVICE_PRICE: `${BASE_URL_INVENTORY}/contract/contractServicePrice`,

  SAVE_WAREHOUSE_DETAILS: `${BASE_URL_INVENTORY}/contract/warehouseDetails`,

  SAVE_COMPANY_CONTRACT: `${BASE_URL_INVENTORY}/contract/saveContract`,

  FETCH_ALL_COMPANIES_CONTRACT: `${BASE_URL_INVENTORY}/contract/getCompaniesContract`,

  FETCH_ALL_COMPANIES_CONTRACT_CAPACITY: `${BASE_URL_INVENTORY}/contract/getCompanyCapacity`,

  GET_CAPACITY_DETAILS_BY_COMPANY_ID: `${BASE_URL_INVENTORY}/contract/getCapacityDetails`,

  FETCH_ALL_CONTRACT_PRICING_DETAILS: `${BASE_URL_INVENTORY}/contract/getAllContractPricing`,

  FETCH_CONTRACT_PRICING_DETAILS_BY_ID: `${BASE_URL_INVENTORY}/contract/getContractPricingDetails`,

  FETCH_EXISTING_WAREHOUSE: `${BASE_URL_INVENTORY}/contract/getWarehouseDetails`,

  GET_CONTRACT_DETAILS_BY_ID: `${BASE_URL_INVENTORY}/contract/getContract`,

  FETCH_EXISTING_SERVICE_PRICING: `${BASE_URL_INVENTORY}/contract/getContractPricingDetails`,

  GET_NEXT_CONTRACT_ID : `${BASE_URL_INVENTORY}/contract/nextContractId`,

  FETCH_ACTIVE_OWNERS: `${BASE_URL_USER}/barrelOwner/active`,

  FETCH_DELETED_OWNERS: `${BASE_URL_USER}/barrelOwner/deleted`,

  SAVE_BARREL_OWNER: `${BASE_URL_USER}/barrelOwner/save`,

  GET_BARREL_OWNER_CONFLICT_COUNT: `${BASE_URL_INVENTORY}/barrel/conflictCount`,

  DELETE_BULK_OWNER: `${BASE_URL_USER}/barrelOwner/deleteOwner`,

  FETCH_BARREL_OWNER_DETAILS: `${BASE_URL_USER}/barrelOwner/getBarrelOwner`,

  FETCH_ACTIVE_OWNERS_COUNT: `${BASE_URL_USER}/barrelOwner/active/count`,

  FETCH_DELETED_OWNERS_COUNT: `${BASE_URL_USER}/barrelOwner/deleted/count`,

  GET_OWNER_LIST_BY_COMPANY_ID: `${BASE_URL_USER}/barrelOwner/getOwnerList`,

  ADD_NEW_CARRIER : `${BASE_URL_SUPPORT}/customerSupport/addCarrier`,

  GET_ALL_CARRIER_LIST : `${BASE_URL_SUPPORT}/customerSupport/getAllCarrierList`,

  GET_ALL_FACILITY_LIST : `${BASE_URL_SUPPORT}/customerSupport/getAllFacilityList`,

  ADD_NEW_FACILITY : `${BASE_URL_SUPPORT}/customerSupport/addFacility`,

  GET_ALL_TRANSFER_REQUEST_LIST : `${BASE_URL_SUPPORT}/customerSupport/getAllTransferRequest`,

  GET_REQUEST_DETAILS_BY_ID : `${BASE_URL_SUPPORT}/customerSupport/getRequestDetails`,

  GET_BARREL_PROOF_DETAILS : `${BASE_URL_SUPPORT}/customerSupport/getBarrelProofDetails`,

  GET_BARREL_VALUATION_DETAILS : `${BASE_URL_SUPPORT}/customerSupport/getBarrelValuationDetails`,

  UPDATE_BARREL_PROOFING_DETAILS : `${BASE_URL_SUPPORT}/customerSupport/updateBarrelProofDetails`,

  EXPORT_BARREL_PROOFING_REPORT : `${BASE_URL_SUPPORT}/customerSupport/exportProofingValue`,

  EXPORT_BARREL_VALUATION_REPORT : `${BASE_URL_SUPPORT}/customerSupport/exportValuationValue`,

  EXPORT_TASTING_REPORT: `${BASE_URL_SUPPORT}/customerSupport/exportTastingValue`,

  UPDATE_BARREL_VALUATION_DETAILS : `${BASE_URL_SUPPORT}/customerSupport/updateBarrelValuationDetails`,

  MANAGE_SCANNED_BARRELS: `${BASE_URL_SUPPORT}/customerSupport/scanBarrels`,

  CUSTOMER_SERVICE_REQUEST_FOR_TRANSFER : `${BASE_URL_SUPPORT}/customerSupport/getTransferRequest`,

  GET_ALL_MASH_BILL_LIST : `${BASE_URL_INVENTORY}/barrel/getAllMashBillList`,

  ADD_NEW_MASH_BILL : `${BASE_URL_INVENTORY}/barrel/addMashBill`,

  MARK_MY_INTEREST: `${BASE_URL_INVENTORY}/barrel/markMyInterest`,

  CHECK_MY_INTEREST: `${BASE_URL_INVENTORY}/barrel/checkMyInterest`,

  WANTED_TO_BUY_CUSTOMER_SERVICE_REQUEST : `${BASE_URL_SUPPORT}/customerSupport/getWantedToBuyIntrestedDetails`,

  SYSTEM_SUGGESTED_CUSTOMER_SERVICE_REQUEST : `${BASE_URL_SUPPORT}/customerSupport/getSystemSuggestedIntrestedDetails`,

  GET_WANTED_TO_BUY_NOTIFICATION_VALUE: `${BASE_URL_USER}/user/getWantedToBuyNotificationValue`,

  SAVE_WANTED_TO_BUY_NOTIFICATION_VALUE: `${BASE_URL_USER}/user/saveWantedToBuyNotificationValue`,

  GET_WANTED_TO_BUY_NOTIFICATION_VALUE_FOR_USER: `${BASE_URL_USER}/user/getWantedToBuyNotificationValueForUser`,

  SAVE_WANTED_TO_BUY_NOTIFICATION_VALUE_FOR_USER: `${BASE_URL_USER}/user/saveWantedToBuyNotificationValueForUser`,

  GET_BARREL_TASTING_NOTE_DETAILS : `${BASE_URL_SUPPORT}/customerSupport/getBarrelTastingNoteDetails`,

  UPDATE_BARREL_TASTING_NOTE_DETAILS : `${BASE_URL_SUPPORT}/customerSupport/updateBarrelTastingNoteDetails`,

  CHECK_ALL_BARREL_TASTING_NOTE_VALUE_PRESENT: `${BASE_URL_SUPPORT}/customerSupport/checkAllBarrelTastingNoteValuePresent`,

  SEARCH_INVENTORY_FOR_DESTINATION: `${INVENTORY_BASE_URL}/searchInventoryForDestination`,

  GET_DESTINATION_BARREL_DETAILS : `${BASE_URL_SUPPORT}/customerSupport/getDestinationBarrelDetails`,

  UPDATE_DESTINATION_BARREL_DETAILS : `${BASE_URL_SUPPORT}/customerSupport/updateDestinationBarrelDetails`,

  CHECK_ALL_DESTINATION_BARREL_VALUE_PRESENT: `${BASE_URL_SUPPORT}/customerSupport/checkAllDestinationBarrelValuePresent`,

  GET_LIQUID_BARREL_DETAILS_BY_ID: `${BASE_URL_INVENTORY}/barrel/getLiquidBarrelDetailsById/`,

  GET_CONTAINER_TIME_LINE_OVERLAY_BY_ID: `${BASE_URL_INVENTORY}/barrel/getContainerTimeLineOverlayById/`,

  GET_RECENT_LIQUID_FILL_DETAILS_BY_ID: `${BASE_URL_INVENTORY}/barrel/getRecentLiquidFillDetailsById/`,

  GET_CONTAINER_REQUEST_MAPPING_HISTORY_BARREL_DETAILS: `${BASE_URL_INVENTORY}/barrel/getContainerRequestMappingHistoryDetails`,

  GET_CONTAINER_BARREL_HISTORY_DETAILS_BY_ID: `${BASE_URL_INVENTORY}/barrel/getContainerBarrelHistoryDetailsById/`,

  GET_TASTING_DETAILS: `${BASE_URL_INVENTORY}/barrel/getTastingDetails`,

  ADD_TASTING_NOTE: `${BASE_URL_INVENTORY}/barrel/addTastingNote`,

  GET_RECENT_LOGIN_ACTIVITY_DATA: `${USER_BASE_URL}/getRecentLoginActivityData`,

  GET_MY_FACILITIES: `${INVENTORY_BASE_URL}/getMyBarrelsFacilities`,

  GET_CUSTOMER_SERVICE_REQUEST_BARREL_BY_ID : `${BASE_URL_SUPPORT}/customerSupport/getCustomerServiceRequestBarrelId/`,

  LOGIN_USER_BY_USER_ID_AND_IMPERSONATE: `${USER_BASE_URL}/impersonate/`,

  IMPERSONATE_TOKEN: `${USER_BASE_URL}/impersonate/token`,

  GET_ALL_FACILITY_BARREL_SUMMARY: `${INVENTORY_BASE_URL}/getFacilityBarrelSummary`,

  GET_ALL_FACILITY_BARREL_DATA: `${INVENTORY_BASE_URL}/getFilteredFacilityData`,

  EXPORT_MY_BARRELS_FACILITIES: `${INVENTORY_BASE_URL}/exportBarrelsFacilities`,

  GET_BARREL_LOT_LEVEL_BY_ID: `${BASE_URL_INVENTORY}/barrel/getBarrelLotLevelById/`,

  EDIT_BARREL_LOT_LEVEL: `${BASE_URL_INVENTORY}/barrel/editBarrelLotLevel`,

  GET_CUSTOMER_SERVICE_REQUEST_LOT_LEVEL_BARREL : `${BASE_URL_SUPPORT}/customerSupport/customerServiceRequestsLotLevelBarrel/`,

  CHECK_COMPANY_ELIGIBILITY: `${BASE_URL_USER}/company/checkCompanyEligibility`,

  REMOVE_COMPANY_FROM_ACTIVELIST: `${BASE_URL_USER}/company/removeCompanyFromActiveList/`,

  FETCH_OWNERSHIP_TRANSFER_LISTING: `${BASE_URL_SUPPORT}/customerSupport/fetchOwnershipTransferListings`,

  EXPORT_MY_OWNERSHIP_TRANSFER: `${BASE_URL_SUPPORT}/customerSupport/exportOwnershipTransfer`,

  EXPORT_MY_LOGISTIC_REQUEST: `${BASE_URL_SUPPORT}/customerSupport/exportLogisticRequest`,

  DOWNLOAD_LOGISTIC_REQUEST_EXPORT_BARREL: `${BASE_URL_SUPPORT}/customerSupport/downloadLogisticRequestExportFile`,
}

